import React, { useEffect, useState } from 'react'
import { Line } from 'react-chartjs-2';
import { darken, lighten, makeStyles, Paper } from '@material-ui/core';
import PropTypes from 'prop-types';

import { COLORS_PROJECT } from '../../constants';



const { color_nav_letter, color_nav, color_back } = COLORS_PROJECT;

const useStyles = makeStyles((theme) => ({
    sizeChart: {
        width: '100%',
        height: '350px',
        backgroundColor: lighten(color_back, 0.8),//lighten(theme.palette.primary.main, 0.5),
    },
}));

const colorChart = '#00416A';

export const StepChart = ({ dataChartStep=[], realtime, namePoint="no hay", size = 350 }) => {
    const classes = useStyles();
    const [dataChart, setDataChart] = useState([]);
    

    useEffect(() => {
        getGraphDataRealtime();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataChartStep]);

    const getGraphDataRealtime = async () => {
        if(dataChartStep!==null){
            setDataChart(dataChartStep);
        }
    };
    

    const getDataLine = () => {
        let dataX = [];
        let dataY = [];

        if (dataChart===null) {
            dataX = [];
            dataY = [];
        }else{
            dataChart.forEach((element) => {
                const time = element.fecha_on;
                const hour = time.substr(11,5);
                dataX.push(hour);
            });
            dataChart.forEach((element) => dataY.push(element.nivel));
        }
        

        const data = {
            labels: dataX,
            datasets: [
                {
                    label: `Nivel Alerta `, //${namePoint}
                    borderColor: colorChart,
                    hoverBorderColor: lighten(colorChart, 0.4),
                    //backgroundColor: color_nav_letter,
                    steppedLine: true,
                    fill: false,
                    data: dataY,
                    pointBorderWidth: 5,
                    pointBorderColor: 'green',
                    
                },
            ],
        };

        return data;
    };

    const d = new Date();
    d.setHours(0,0,0,0);

    const options = {
        maintainAspectRatio: false,
        responsive: true,
        title: {
            display: true,
            text: `${namePoint}`,
            fontSize: 20,
            fontColor: darken(color_nav, 0.45),
        },
        legend: {
            display: true,
            position: 'top',
            labels: {
                fontColor: darken(color_nav_letter, 1),
            },
        },
        scales: {
            xAxes: [
                {
                    gridLines: {
                        color: color_back,
                    },
                    scaleLabel: {
                        display: true,
                        labelString: 'Horas'
                    },
                },
            ],
            yAxes: [
                {
                    gridLines: {
                        color: color_back,
                    },
                    ticks: {
                        beginAtZero: true,
                        callback: function(value) {if (value % 1 === 0) {return value;}}
                    },
                    scaleLabel: {
                        display: true,
                        labelString: 'Nivel'
                    },
                    
                },
            ],
        },
    };
    return (
        <Paper className={classes.sizeChart} style={{ height: size }}>
            <Line data={getDataLine()} options={options} />
        </Paper>
    )
}


StepChart.propTypes={
    dataChartStep: PropTypes.array.isRequired,
    realtime: PropTypes.bool,
    size: PropTypes.number,
    namePoint: PropTypes.string,
}